webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ainhoa.6778652.jpg";

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fanny.0388191.jpg";

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/frederique.fb17247.jpg";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/michel.a9a5ed5.jpg";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/catalan.bcb7bda.png";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/england.eaae527.jpg";

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2IDU2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1NiA1NjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+CjxwYXRoIGQ9Ik0yOCwwQzEyLjU2MSwwLDAsMTIuNTYxLDAsMjhzMTIuNTYxLDI4LDI4LDI4czI4LTEyLjU2MSwyOC0yOFM0My40MzksMCwyOCwweiBNNDAsNDFIMTZjLTEuMTA0LDAtMi0wLjg5Ni0yLTJzMC44OTYtMiwyLTIgIGgyNGMxLjEwNCwwLDIsMC44OTYsMiwyUzQxLjEwNCw0MSw0MCw0MXogTTQwLDMwSDE2Yy0xLjEwNCwwLTItMC44OTYtMi0yczAuODk2LTIsMi0yaDI0YzEuMTA0LDAsMiwwLjg5NiwyLDJTNDEuMTA0LDMwLDQwLDMweiAgIE00MCwxOUgxNmMtMS4xMDQsMC0yLTAuODk2LTItMnMwLjg5Ni0yLDItMmgyNGMxLjEwNCwwLDIsMC44OTYsMiwyUzQxLjEwNCwxOSw0MCwxOXoiIGZpbGw9IiNmZmYxMzMiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABAAAAAKrCAIAAADgdGjDAAAABmJLR0QA/wD/AP+gvaeTAAAN7UlEQVR4nO3asQkCQQAFUVcuEARDQ0swt3+xALGSi8y0i91g3qvgpwN/vM63AwAA0HBcPQAAAJhHAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBku9y/qzcAAACTjN9z9QQAAGAWFyAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAEDI+DyuqzcAAACTbPv7tHoDAAAwiQsQAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACECAAAAAgRAAAAECIAAAAgRAAAAECIAAAAgBABAAAAIQIAAABCBAAAAIQIAAAACBEAAAAQIgAAACBEAAAAQIgAAACAEAEAAAAhAgAAAEIEAAAAhAgAAAAIEQAAABAiAAAAIEQAAABAiAAAAIAQAQAAACECAAAAQgQAAACE/AHXrAwt6FCpmwAAAABJRU5ErkJggg=="

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(53)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(130),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {}
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cat_LanguageMenu_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cat_LanguageMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Cat_LanguageMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cat_Home_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cat_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Cat_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cat_Philosophy_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cat_Philosophy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Cat_Philosophy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cat_Infos_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cat_Infos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Cat_Infos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Cat_Staff_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Cat_Staff_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Cat_Staff_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cat_ServicesHome_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cat_ServicesHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Cat_ServicesHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cat_ServicesRDV_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cat_ServicesRDV_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Cat_ServicesRDV_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Cat_ContactUs_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Cat_ContactUs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Cat_ContactUs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cat_Order_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cat_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Cat_Order_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat',
  components: {
    LanguageMenu: __WEBPACK_IMPORTED_MODULE_0__Cat_LanguageMenu_vue___default.a,
    Home: __WEBPACK_IMPORTED_MODULE_1__Cat_Home_vue___default.a,
    Infos: __WEBPACK_IMPORTED_MODULE_3__Cat_Infos_vue___default.a,
    Staff: __WEBPACK_IMPORTED_MODULE_4__Cat_Staff_vue___default.a,
    Philosophy: __WEBPACK_IMPORTED_MODULE_2__Cat_Philosophy_vue___default.a,
    ServicesHome: __WEBPACK_IMPORTED_MODULE_5__Cat_ServicesHome_vue___default.a,
    ServicesRDV: __WEBPACK_IMPORTED_MODULE_6__Cat_ServicesRDV_vue___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_7__Cat_ContactUs_vue___default.a,
    Order: __WEBPACK_IMPORTED_MODULE_8__Cat_Order_vue___default.a
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      subject: '',
      mailto: '',
      visibleSendButton: false,
      error: "Si us plau ompli tots els quadrats"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.subject !== '') {
        var re = /\S+@\S+\.\S+/;
        if (!re.test(this.email)) {
          this.error = "El format de l'email no és correcte";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=" + this.subject + "&body=" + this.message + "%0D%0AEnvoyé par : " + this.email;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    subject: function subject() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var elemSize = elemBottom - elemTop;
      var isVisible = void 0;
      if (elemSize > window.innerHeight && elemBottom >= window.innerHeight && elemTop <= 0) {
        isVisible = true;
      } else if (elemSize < window.innerHeight && elemBottom < window.innerHeight && elemTop >= 0) {
        isVisible = true;
      } else if (elemTop >= 0) {
        isVisible = true;
      } else {
        isVisible = false;
      }
      return isVisible;
    },
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
      console.log("coucou", this.menuOpen);
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      if (context.isScrolledIntoView(document.getElementById('home'))) {
        context.hash = 'home';
      } else if (context.isScrolledIntoView(document.getElementById('infos'))) {
        context.hash = 'infos';
      } else if (context.isScrolledIntoView(document.getElementById('staff'))) {
        context.hash = 'staff';
      } else if (context.isScrolledIntoView(document.getElementById('philosophy'))) {
        context.hash = 'philosophy';
      } else if (context.isScrolledIntoView(document.getElementById('servicesHome'))) {
        context.hash = 'servicesHome';
      } else if (context.isScrolledIntoView(document.getElementById('contactUs'))) {
        context.hash = 'contactUs';
      } else if (context.isScrolledIntoView(document.getElementById('order'))) {
        context.hash = 'order';
      }

      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      name: '',
      firstname: '',
      phone: '',
      mailto: '',
      visibleSendButton: false,
      error: "Si us plau omplir tots els quadrats"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.phone !== '' && this.name !== '' && this.firstname !== '') {
        var re = /\S+@\S+\.\S+/;
        var ret = /^[\+]?[0-9]{6,}$/im;
        if (!re.test(this.email)) {
          this.error = "El format de l'email no és correcte";
          this.visibleSendButton = false;
        } else if (!ret.test(this.phone)) {
          this.error = "El format del número de telèfon no és correcte";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=Commande de " + this.name + " " + this.firstname + "&body=" + this.message + "%0D%0AContact : " + this.email + " " + this.phone;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    phone: function phone() {
      this.checkFields();
    },
    name: function name() {
      this.checkFields();
    },
    firstname: function firstname() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__En_LanguageMenu_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__En_LanguageMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__En_LanguageMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__En_Home_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__En_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__En_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__En_Philosophy_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__En_Philosophy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__En_Philosophy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__En_Infos_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__En_Infos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__En_Infos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__En_Staff_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__En_Staff_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__En_Staff_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__En_ServicesHome_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__En_ServicesHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__En_ServicesHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__En_ServicesRDV_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__En_ServicesRDV_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__En_ServicesRDV_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__En_ContactUs_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__En_ContactUs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__En_ContactUs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__En_Order_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__En_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__En_Order_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'en',
  components: {
    LanguageMenu: __WEBPACK_IMPORTED_MODULE_0__En_LanguageMenu_vue___default.a,
    Home: __WEBPACK_IMPORTED_MODULE_1__En_Home_vue___default.a,
    Infos: __WEBPACK_IMPORTED_MODULE_3__En_Infos_vue___default.a,
    Staff: __WEBPACK_IMPORTED_MODULE_4__En_Staff_vue___default.a,
    Philosophy: __WEBPACK_IMPORTED_MODULE_2__En_Philosophy_vue___default.a,
    ServicesHome: __WEBPACK_IMPORTED_MODULE_5__En_ServicesHome_vue___default.a,
    ServicesRDV: __WEBPACK_IMPORTED_MODULE_6__En_ServicesRDV_vue___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_7__En_ContactUs_vue___default.a,
    Order: __WEBPACK_IMPORTED_MODULE_8__En_Order_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      subject: '',
      mailto: '',
      visibleSendButton: false,
      error: "Please fill all the fields"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.subject !== '') {
        var re = /\S+@\S+\.\S+/;
        if (!re.test(this.email)) {
          this.error = "L'adresse email est mal formatée";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=" + this.subject + "&body=" + this.message + "%0D%0AEnvoyé par : " + this.email;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    subject: function subject() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var elemSize = elemBottom - elemTop;
      var isVisible = void 0;
      if (elemSize > window.innerHeight && elemBottom >= window.innerHeight && elemTop <= 0) {
        isVisible = true;
      } else if (elemSize < window.innerHeight && elemBottom < window.innerHeight && elemTop >= 0) {
        isVisible = true;
      } else if (elemTop >= 0) {
        isVisible = true;
      } else {
        isVisible = false;
      }
      return isVisible;
    },
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
      console.log("coucou", this.menuOpen);
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      if (context.isScrolledIntoView(document.getElementById('home'))) {
        context.hash = 'home';
      } else if (context.isScrolledIntoView(document.getElementById('infos'))) {
        context.hash = 'infos';
      } else if (context.isScrolledIntoView(document.getElementById('staff'))) {
        context.hash = 'staff';
      } else if (context.isScrolledIntoView(document.getElementById('philosophy'))) {
        context.hash = 'philosophy';
      } else if (context.isScrolledIntoView(document.getElementById('servicesHome'))) {
        context.hash = 'servicesHome';
      } else if (context.isScrolledIntoView(document.getElementById('contactUs'))) {
        context.hash = 'contactUs';
      } else if (context.isScrolledIntoView(document.getElementById('order'))) {
        context.hash = 'order';
      }

      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      name: '',
      firstname: '',
      phone: '',
      mailto: '',
      visibleSendButton: false,
      error: "Please fill all the fields"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.phone !== '' && this.name !== '' && this.firstname !== '') {
        var re = /\S+@\S+\.\S+/;
        var ret = /^[\+]?[0-9]{6,}$/im;
        if (!re.test(this.email)) {
          this.error = "The email is badly formatted";
          this.visibleSendButton = false;
        } else if (!ret.test(this.phone)) {
          this.error = "The phone number is badly formatted";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=Commande de " + this.name + " " + this.firstname + "&body=" + this.message + "%0D%0AContact : " + this.email + " " + this.phone;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    phone: function phone() {
      this.checkFields();
    },
    name: function name() {
      this.checkFields();
    },
    firstname: function firstname() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Es_LanguageMenu_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Es_LanguageMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Es_LanguageMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Es_Home_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Es_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Es_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Es_Philosophy_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Es_Philosophy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Es_Philosophy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Es_Infos_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Es_Infos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Es_Infos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Es_Staff_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Es_Staff_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Es_Staff_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Es_ServicesHome_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Es_ServicesHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Es_ServicesHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Es_ServicesRDV_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Es_ServicesRDV_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Es_ServicesRDV_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Es_ContactUs_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Es_ContactUs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Es_ContactUs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Es_Order_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Es_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Es_Order_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'es',
  components: {
    LanguageMenu: __WEBPACK_IMPORTED_MODULE_0__Es_LanguageMenu_vue___default.a,
    Home: __WEBPACK_IMPORTED_MODULE_1__Es_Home_vue___default.a,
    Infos: __WEBPACK_IMPORTED_MODULE_3__Es_Infos_vue___default.a,
    Staff: __WEBPACK_IMPORTED_MODULE_4__Es_Staff_vue___default.a,
    Philosophy: __WEBPACK_IMPORTED_MODULE_2__Es_Philosophy_vue___default.a,
    ServicesHome: __WEBPACK_IMPORTED_MODULE_5__Es_ServicesHome_vue___default.a,
    ServicesRDV: __WEBPACK_IMPORTED_MODULE_6__Es_ServicesRDV_vue___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_7__Es_ContactUs_vue___default.a,
    Order: __WEBPACK_IMPORTED_MODULE_8__Es_Order_vue___default.a
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      subject: '',
      mailto: '',
      visibleSendButton: false,
      error: "Por favor complete todas las zonas de texto"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.subject !== '') {
        var re = /\S+@\S+\.\S+/;
        if (!re.test(this.email)) {
          this.error = "El formato del email no es correcto";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=" + this.subject + "&body=" + this.message + "%0D%0AEnvoyé par : " + this.email;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    subject: function subject() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var elemSize = elemBottom - elemTop;
      var isVisible = void 0;
      if (elemSize > window.innerHeight && elemBottom >= window.innerHeight && elemTop <= 0) {
        isVisible = true;
      } else if (elemSize < window.innerHeight && elemBottom < window.innerHeight && elemTop >= 0) {
        isVisible = true;
      } else if (elemTop >= 0) {
        isVisible = true;
      } else {
        isVisible = false;
      }
      return isVisible;
    },
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
      console.log("coucou", this.menuOpen);
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      if (context.isScrolledIntoView(document.getElementById('home'))) {
        context.hash = 'home';
      } else if (context.isScrolledIntoView(document.getElementById('infos'))) {
        context.hash = 'infos';
      } else if (context.isScrolledIntoView(document.getElementById('staff'))) {
        context.hash = 'staff';
      } else if (context.isScrolledIntoView(document.getElementById('philosophy'))) {
        context.hash = 'philosophy';
      } else if (context.isScrolledIntoView(document.getElementById('servicesHome'))) {
        context.hash = 'servicesHome';
      } else if (context.isScrolledIntoView(document.getElementById('contactUs'))) {
        context.hash = 'contactUs';
      } else if (context.isScrolledIntoView(document.getElementById('order'))) {
        context.hash = 'order';
      }

      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      name: '',
      firstname: '',
      phone: '',
      mailto: '',
      visibleSendButton: false,
      error: "Por favor complete todas las zonas de texto"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.phone !== '' && this.name !== '' && this.firstname !== '') {
        var re = /\S+@\S+\.\S+/;
        var ret = /^[\+]?[0-9]{6,}$/im;
        if (!re.test(this.email)) {
          this.error = "El formato del email no es correcto";
          this.visibleSendButton = false;
        } else if (!ret.test(this.phone)) {
          this.error = "El formato del número de teléfono no es correcto";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=Commande de " + this.name + " " + this.firstname + "&body=" + this.message + "%0D%0AContact : " + this.email + " " + this.phone;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    phone: function phone() {
      this.checkFields();
    },
    name: function name() {
      this.checkFields();
    },
    firstname: function firstname() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fr_LanguageMenu_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fr_LanguageMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Fr_LanguageMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fr_Home_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fr_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Fr_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fr_Philosophy_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fr_Philosophy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Fr_Philosophy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fr_Infos_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fr_Infos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Fr_Infos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Fr_Staff_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Fr_Staff_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Fr_Staff_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Fr_ServicesHome_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Fr_ServicesHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Fr_ServicesHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fr_ServicesRDV_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fr_ServicesRDV_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Fr_ServicesRDV_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Fr_ContactUs_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Fr_ContactUs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Fr_ContactUs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fr_Order_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fr_Order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Fr_Order_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fr',
  components: {
    LanguageMenu: __WEBPACK_IMPORTED_MODULE_0__Fr_LanguageMenu_vue___default.a,
    Home: __WEBPACK_IMPORTED_MODULE_1__Fr_Home_vue___default.a,
    Infos: __WEBPACK_IMPORTED_MODULE_3__Fr_Infos_vue___default.a,
    Staff: __WEBPACK_IMPORTED_MODULE_4__Fr_Staff_vue___default.a,
    Philosophy: __WEBPACK_IMPORTED_MODULE_2__Fr_Philosophy_vue___default.a,
    ServicesHome: __WEBPACK_IMPORTED_MODULE_5__Fr_ServicesHome_vue___default.a,
    ServicesRDV: __WEBPACK_IMPORTED_MODULE_6__Fr_ServicesRDV_vue___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_7__Fr_ContactUs_vue___default.a,
    Order: __WEBPACK_IMPORTED_MODULE_8__Fr_Order_vue___default.a
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      subject: '',
      mailto: '',
      visibleSendButton: false,
      error: "Merci de remplir tous les champs"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.subject !== '') {
        var re = /\S+@\S+\.\S+/;
        if (!re.test(this.email)) {
          this.error = "L'adresse email est mal formatée";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=" + this.subject + "&body=" + this.message + "%0D%0AEnvoyé par : " + this.email;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    subject: function subject() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    isScrolledIntoView: function isScrolledIntoView(el) {
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var elemSize = elemBottom - elemTop;
      var isVisible = void 0;
      if (elemSize > window.innerHeight && elemBottom >= window.innerHeight && elemTop <= 0) {
        isVisible = true;
      } else if (elemSize < window.innerHeight && elemBottom < window.innerHeight && elemTop >= 0) {
        isVisible = true;
      } else if (elemTop >= 0) {
        isVisible = true;
      } else {
        isVisible = false;
      }
      return isVisible;
    },
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
      console.log("coucou", this.menuOpen);
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      if (context.isScrolledIntoView(document.getElementById('home'))) {
        context.hash = 'home';
      } else if (context.isScrolledIntoView(document.getElementById('infos'))) {
        context.hash = 'infos';
      } else if (context.isScrolledIntoView(document.getElementById('staff'))) {
        context.hash = 'staff';
      } else if (context.isScrolledIntoView(document.getElementById('philosophy'))) {
        context.hash = 'philosophy';
      } else if (context.isScrolledIntoView(document.getElementById('servicesHome'))) {
        context.hash = 'servicesHome';
      } else if (context.isScrolledIntoView(document.getElementById('contactUs'))) {
        context.hash = 'contactUs';
      } else if (context.isScrolledIntoView(document.getElementById('order'))) {
        context.hash = 'order';
      }

      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
  },
  mounted: function mounted() {
    var context = this;
    window.setInterval(function () {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = window.innerHeigh;
    }, 100);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      message: '',
      name: '',
      firstname: '',
      phone: '',
      mailto: '',
      visibleSendButton: false,
      error: "Merci de remplir tous les champs"
    };
  },

  methods: {
    checkFields: function checkFields() {
      if (this.email !== '' && this.message !== '' && this.phone !== '' && this.name !== '' && this.firstname !== '') {
        var re = /\S+@\S+\.\S+/;
        var ret = /^[\+]?[0-9]{6,}$/im;
        if (!re.test(this.email)) {
          this.error = "L'adresse email est mal formatée";
          this.visibleSendButton = false;
        } else if (!ret.test(this.phone)) {
          this.error = "Le numéro de téléphone est mal formaté";
          this.visibleSendButton = false;
        } else {
          this.error = "";
          this.visibleSendButton = true;
          this.mailto = "mailto:vetopas@andorra.ad?subject=Commande de " + this.name + " " + this.firstname + "&body=" + this.message + "%0D%0AContact : " + this.email + " " + this.phone;
        }
      }
    }
  },
  watch: {
    email: function email() {
      this.checkFields();
    },
    message: function message() {
      this.checkFields();
    },
    phone: function phone() {
      this.checkFields();
    },
    name: function name() {
      this.checkFields();
    },
    firstname: function firstname() {
      this.checkFields();
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_En_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_En_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_En_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Es_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Es_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Es_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cat_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Cat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Fr_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Fr_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Fr_vue__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_4__components_En_vue___default.a }, { path: '/en', component: __WEBPACK_IMPORTED_MODULE_4__components_En_vue___default.a }, { path: '/es', component: __WEBPACK_IMPORTED_MODULE_5__components_Es_vue___default.a }, { path: '/cat', component: __WEBPACK_IMPORTED_MODULE_6__components_Cat_vue___default.a }, { path: '/fr', component: __WEBPACK_IMPORTED_MODULE_7__components_Fr_vue___default.a }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes });

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a, En: __WEBPACK_IMPORTED_MODULE_4__components_En_vue___default.a, Cat: __WEBPACK_IMPORTED_MODULE_6__components_Cat_vue___default.a, Es: __WEBPACK_IMPORTED_MODULE_5__components_Es_vue___default.a, Fr: __WEBPACK_IMPORTED_MODULE_7__components_Fr_vue___default.a }
});

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(129),
  /* scopeId */
  "data-v-4c0b2b7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  "data-v-0806a331",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(64)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(141),
  /* scopeId */
  "data-v-70bd04ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(57)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(134),
  /* scopeId */
  "data-v-6042c929",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(136),
  /* scopeId */
  "data-v-65d5c6ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(67)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(144),
  /* scopeId */
  "data-v-78d2e143",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(68)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(145),
  /* scopeId */
  "data-v-7b74ffaf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(71)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(148),
  /* scopeId */
  "data-v-7feace64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(125),
  /* scopeId */
  "data-v-2dfa2d04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  "data-v-7b9b83f1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(75)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(152),
  /* scopeId */
  "data-v-dcb7d4c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(65)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(142),
  /* scopeId */
  "data-v-71b25898",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(63)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(140),
  /* scopeId */
  "data-v-6ee8a094",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(43)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  "data-v-0fe6a1e1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(126),
  /* scopeId */
  "data-v-3b4d976e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(76)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(153),
  /* scopeId */
  "data-v-ebca51cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(41)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(117),
  /* scopeId */
  "data-v-0cc6dd99",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(74)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(151),
  /* scopeId */
  "data-v-d9d8771a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  "data-v-3ce49736",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(55)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(132),
  /* scopeId */
  "data-v-57134b37",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(56)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(133),
  /* scopeId */
  "data-v-5a29d65d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  "data-v-45c20b2f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  "data-v-0f43c0b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(72)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(149),
  /* scopeId */
  "data-v-b9b2266e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(135),
  /* scopeId */
  "data-v-60f441b5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(73)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(150),
  /* scopeId */
  "data-v-bfcf98c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(146),
  /* scopeId */
  "data-v-7b8b4238",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(143),
  /* scopeId */
  "data-v-76c9ea58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(44)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  "data-v-10a2e64e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(137),
  /* scopeId */
  "data-v-66126e0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(54)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(131),
  /* scopeId */
  "data-v-4eda8ad1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(62)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(139),
  /* scopeId */
  "data-v-6b2b1244",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(45)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(121),
  /* scopeId */
  "data-v-123eeceb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(138),
  /* scopeId */
  "data-v-6a0cc157",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(46)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-140037bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-234f9654",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fr"
    }
  }, [_c('LanguageMenu'), _vm._v(" "), _c('Home'), _vm._v(" "), _c('Infos'), _vm._v(" "), _c('Staff'), _vm._v(" "), _c('Philosophy'), _vm._v(" "), _c('ServicesHome'), _vm._v(" "), _c('ServicesRDV'), _vm._v(" "), _c('ContactUs'), _vm._v(" "), _c('Order')], 1)
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fr"
    }
  }, [_c('LanguageMenu'), _vm._v(" "), _c('Home'), _vm._v(" "), _c('Infos'), _vm._v(" "), _c('Staff'), _vm._v(" "), _c('Philosophy'), _vm._v(" "), _c('ServicesHome'), _vm._v(" "), _c('ServicesRDV'), _vm._v(" "), _c('ContactUs'), _vm._v(" "), _c('Order')], 1)
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fr"
    }
  }, [_c('LanguageMenu'), _vm._v(" "), _c('Home'), _vm._v(" "), _c('Infos'), _vm._v(" "), _c('Staff'), _vm._v(" "), _c('Philosophy'), _vm._v(" "), _c('ServicesHome'), _vm._v(" "), _c('ServicesRDV'), _vm._v(" "), _c('ContactUs'), _vm._v(" "), _c('Order')], 1)
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hamburgerButton"
  }, [_c('img', {
    attrs: {
      "id": "menuButton",
      "src": __webpack_require__(8)
    },
    on: {
      "click": _vm.toggleMenu
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inici")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inici")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informacions pràctiques")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informacions pràctiques")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("El nostre equip")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("El nostre equip")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofia")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofia")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Serveis proposats")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Serveis proposats")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contactar-nos")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contactar-nos")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Comanda")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Comanda")])])])]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "menuMobile"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inici")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inici")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informacions pràctiques")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informacions pràctiques")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("El nostre equip")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("El nostre equip")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofia")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofia")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Serveis proposats")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Serveis proposats")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contactar-nos")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contactar-nos")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Comanda")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Comanda")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "close"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("Tancar el menu")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeContainer"
  }, [_c('h1', [_vm._v("Benvinguts a Vetopas ")])])
}]}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Serices on appointment")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Surgery")]), _vm._v(" "), _c('p', [_vm._v("Soft tissue surgery")]), _vm._v(" "), _c('p', [_vm._v("Ovariectomy")]), _vm._v(" "), _c('p', [_vm._v("Castration")]), _vm._v(" "), _c('p', [_vm._v("Dental care")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consultation")]), _vm._v(" "), _c('p', [_vm._v("A global approach based on nutrition and behavior\n          to achieve together the welfare of your companion.")]), _vm._v(" "), _c('p', [_vm._v("Homeopathic consultations")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Technical platform")]), _vm._v(" "), _c('p', [_vm._v("Ultrasound")]), _vm._v(" "), _c('p', [_vm._v("Radiography")]), _vm._v(" "), _c('p', [_vm._v("Hematology")]), _vm._v(" "), _c('p', [_vm._v("Biochemistry")])])])])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "order"
    }
  }, [_c('h2', [_vm._v(" Pedido ")]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Apellido"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nombre"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Número de teléfono"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Su email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Su orden"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Pedido")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "order"
    }
  }, [_c('h2', [_vm._v(" Order")]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Your order"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Order")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Accueil")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Accueil")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations pratiques")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations pratiques")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notre équipe")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notre équipe")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophie")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophie")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services proposés")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services proposés")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Commander")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Commander")])])])]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "menuMobile"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Accueil")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Accueil")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations pratiques")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations pratiques")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notre équipe")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notre équipe")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophie")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophie")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services proposés")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services proposés")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Commander")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Commander")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "close"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("Fermer le menu")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeContainer"
  }, [_c('h1', [_vm._v("Bienvenue sur Vetopas")])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "philosophy"
    }
  }, [_c('h2', [_vm._v("Une approche globale de la santé basée sur la prévention")]), _vm._v(" "), _c('div', {
    staticClass: "philosophy"
  }, [_c('h3', [_c('strong', [_vm._v("Nutrition")])]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("Comportement")])]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("Homéopathie")])])])])])
}]}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Services sur rendez-vous ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Chirurgie")]), _vm._v(" "), _c('p', [_vm._v("Chirurgie des tissus mous")]), _vm._v(" "), _c('p', [_vm._v("Ovariectomie")]), _vm._v(" "), _c('p', [_vm._v("Castration")]), _vm._v(" "), _c('p', [_vm._v("Soins dentaires")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consultation")]), _vm._v(" "), _c('p', [_vm._v("Approche globale basée sur l' "), _c('strong', [_vm._v("alimentation")]), _vm._v(" et le comportement pour\n          atteindre ensemble le "), _c('strong', [_vm._v("bien être")]), _vm._v(" de votre compagnon.")]), _vm._v(" "), _c('p', [_vm._v("Consultations homéopatiques")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Plateau technique")]), _vm._v(" "), _c('p', [_vm._v("Echograhie")]), _vm._v(" "), _c('p', [_vm._v("Radiographie")]), _vm._v(" "), _c('p', [_vm._v("Hématologie")]), _vm._v(" "), _c('p', [_vm._v("Biochimie")])])])])])
}]}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h2', [_vm._v(" Notre équipe ")]), _vm._v(" "), _c('div', {
    staticClass: "staff"
  }, [_c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(2),
      "alt": "Estéfania XARPELL, Vétérinaire"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Estéfania XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Diplomée de l'Ecole "), _c('strong', [_vm._v("Vétérinaire")]), _vm._v(" de Toulouse, CES de nutrition de\n          l'école "), _c('strong', [_vm._v("vétérinaire")]), _vm._v(" Maison Alfort, DU d'homéopathie de\n      la faculté de médecine de Marseille.")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1),
      "alt": "Ainhoa XARPELL, Pharmacienne"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Ainhoa XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Diplômée de l'université de pharmacie de\n            Barcelone (UB), ingénieure\n            de l'école supérieure de chimie physique électronique\n            de Lyon (CPE Lyon)")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4),
      "alt": "Michel HEINZELMEIER, Relations client"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Michel HEINZELMEIER")]), _vm._v(" "), _c('p', [_vm._v("Ingénieur, CAAE de l'IAE de Toulon")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "imgF"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "Frédérique CHADERAT, Responsable informatique"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Frédérique CHADERAT")]), _vm._v(" "), _c('p', [_vm._v("Ingénieur. Responsable informatique")])])])])])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fr"
    }
  }, [_c('LanguageMenu'), _vm._v(" "), _c('Home'), _vm._v(" "), _c('Infos'), _vm._v(" "), _c('Staff'), _vm._v(" "), _c('Philosophy'), _vm._v(" "), _c('ServicesHome'), _vm._v(" "), _c('ServicesRDV'), _vm._v(" "), _c('ContactUs'), _vm._v(" "), _c('Order')], 1)
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h2', [_vm._v(" Nostre equip ")]), _vm._v(" "), _c('div', {
    staticClass: "staff"
  }, [_c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(2),
      "alt": "Estéfania XARPELL, Vétérinaire"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Estéfania XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduada de l'Escola Veterinària de Tolosa, CES d'alimentació de l'Escola veterinària Maison Alfort, DU d'homeopatia de la Facultat de Medicina de Marsella.")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1),
      "alt": "Ainhoa XARPELL, Pharmacienne"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Ainhoa XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduada de l'Universitat de Farmàcia de Barcelona (UB), enginyera de l'Escola Superior de Química Electrònica Electrònica de Lyon (CPE Lyon)")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4),
      "alt": "Michel HEINZELMEIER, Relations client"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Michel HEINZELMEIER")]), _vm._v(" "), _c('p', [_vm._v("Enginyer, CAAE de l'IAE de Toulon")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "imgF"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "Frédérique CHADERAT, Responsable informatique"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Frédérique CHADERAT")]), _vm._v(" "), _c('p', [_vm._v("Enginyer. Responsable informàtic")])])])])])
}]}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "philosophy"
    }
  }, [_c('h2', [_vm._v("A health global approach based on prevention")]), _vm._v(" "), _c('div', {
    staticClass: "philosophy"
  }, [_c('h3', [_vm._v("Nutrion")]), _vm._v(" "), _c('h3', [_vm._v("Behaviour")]), _vm._v(" "), _c('h3', [_vm._v("Homeopathy")])])])])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "contactUs"
    }
  }, [_c('h2', [_vm._v(" Contáctenos ")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Su email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Sujeto"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "textarea",
    attrs: {
      "type": "textarea",
      "rv-model": "message"
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Enviar email")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/en"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/cat"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/fr"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "contactUs"
    }
  }, [_c('h2', [_vm._v(" Contactar-nos ")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "El teu email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subjecte"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "textarea",
    attrs: {
      "type": "textarea",
      "rv-model": "message"
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Enviar email")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('link', {
    attrs: {
      "href": "https://fonts.googleapis.com/css?family=Arvo",
      "rel": "stylesheet"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/en"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/cat"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/es"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hamburgerButton"
  }, [_c('img', {
    attrs: {
      "id": "menuButton",
      "src": __webpack_require__(8)
    },
    on: {
      "click": _vm.toggleMenu
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inicio")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inicio")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informaciones prácticas")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informaciones prácticas")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nuestro equipo")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nuestro equipo")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofía")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofía")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Servicios ofrecidos")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Servicios ofrecidos")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contáctenos")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contáctenos")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pedido")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pedido")])])])]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "menuMobile"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inicio")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inicio")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informaciones prácticas")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informaciones prácticas")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nuestro equipo")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nuestro equipo")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofía")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Filosofía")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Servicios ofrecidos")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Servicios ofrecidos")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contáctenos")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contáctenos")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pedido")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pedido")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "close"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("Cerrar el menú")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeContainer"
  }, [_c('h1', [_vm._v("Bienvenidos a Vetopas")])])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "infos"
    }
  }, [_c('h2', [_vm._v(" Informaciones prácticas ")]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Dónde encontrarnos ")]), _vm._v(" "), _c('p', [_vm._v(" HOSPITAL VETERINARI")]), _vm._v(" "), _c('p', [_vm._v(" Carrer Sant Jordi n°37")]), _vm._v(" "), _c('p', [_vm._v(" AD200 PAS DE LA CASA")]), _vm._v(" "), _c('p', [_vm._v("ANDORRA")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.google.fr/maps/place/Hospital+Veterinari/@42.5433291,1.7292353,17z/data=!3m1!4b1!4m5!3m4!1s0x12af7d8c7a8fdecb:0x9b2dad0f8b06fd2e!8m2!3d42.5433252!4d1.7314186",
      "target": "_blank"
    }
  }, [_vm._v("Ver mapa")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Nuestros horarios ")]), _vm._v(" "), _c('p', [_vm._v("9h30-13h00 y 15h00-19h00")]), _vm._v(" "), _c('p', [_vm._v(" La clínica está cerrada los días 01/01, 14/03, 8/09, 25/12")]), _vm._v(" "), _c('p', [_vm._v(" Los tratamientos se hacen unicamente con cita  ")]), _vm._v(" "), _c('p', [_vm._v(" Para la cirugía, los animales se dejan en la mañana a las 8h30\n           y se recuperan a las 16h ")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Contáctenos ")]), _vm._v(" "), _c('p', [_vm._v(" (FR) +33681459871 ")]), _vm._v(" "), _c('p', [_vm._v(" (AND) +376855536 ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:vetopas@andorra.ad",
      "target": "_blank"
    }
  }, [_vm._v("vetopas@andorra.ad")])])])])])
}]}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/en"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/fr"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/es"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Servicios ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consejo veterinario gratuito")]), _vm._v(" "), _c('p', [_vm._v("Le escuchamos")]), _vm._v(" "), _c('p', [_vm._v("Le ofrecemos una solución global personalizada")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Venta")]), _vm._v(" "), _c('p', [_vm._v("Solo ofrecemos productos de alta calidad que hemos estudiado y probado")]), _vm._v(" "), _c('p', [_vm._v("Garantizamos en todos los productos el precio más bajo del mercado")])])])])])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "order"
    }
  }, [_c('h2', [_vm._v(" Comanda ")]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nom"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Cognom"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Número de telèfon"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Vostra pedida"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Comanda")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "infos"
    }
  }, [_c('h2', [_vm._v(" Informations pratiques")]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Où nous trouver ")]), _vm._v(" "), _c('p', [_vm._v(" HOPITAL "), _c('strong', [_vm._v("VETERINAIRE")])]), _vm._v(" "), _c('p', [_vm._v(" Carrer Sant Jordi n°37")]), _vm._v(" "), _c('p', [_vm._v(" AD200 "), _c('strong', [_vm._v("PAS DE LA CASE")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("ANDORRE")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.google.fr/maps/place/Hospital+Veterinari/@42.5433291,1.7292353,17z/data=!3m1!4b1!4m5!3m4!1s0x12af7d8c7a8fdecb:0x9b2dad0f8b06fd2e!8m2!3d42.5433252!4d1.7314186",
      "target": "_blank"
    }
  }, [_vm._v("Voir carte")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Nos horaires ")]), _vm._v(" "), _c('p', [_vm._v("9h30-13h00 et 15h00-19h00")]), _vm._v(" "), _c('p', [_vm._v(" La "), _c('strong', [_vm._v("clinique")]), _vm._v(" est fermée les 01/01, 14/03, 8/09, 25/12")]), _vm._v(" "), _c('p', [_vm._v(" Les soins sur rendez-vous seulement ")]), _vm._v(" "), _c('p', [_vm._v(" Pour la chirurgie, les "), _c('strong', [_vm._v("animaux")]), _vm._v(" sont déposés le matin à 8h30\n        et récupérés à 16h")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Nous contacter ")]), _vm._v(" "), _c('p', [_vm._v(" (FR) +33681459871 ")]), _vm._v(" "), _c('p', [_vm._v(" ("), _c('strong', [_vm._v("AND")]), _vm._v(") +376855536 ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:vetopas@andorra.ad",
      "target": "_blank"
    }
  }, [_vm._v("vetopas@andorra.ad")])])])])])
}]}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Services à l'accueil ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Conseil "), _c('strong', [_vm._v("vétérinaire")]), _vm._v(" gratuit")]), _vm._v(" "), _c('p', [_vm._v("Nous vous écoutons")]), _vm._v(" "), _c('p', [_vm._v("Nous vous fournissons une solution globale personnalisée")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Vente")]), _vm._v(" "), _c('p', [_vm._v("Nous ne proposons que des "), _c('strong', [_vm._v("croquettes")]), _vm._v(" et "), _c('strong', [_vm._v(" des antiparasitaires")]), _vm._v(" haut de gamme que nous avons étudiés\n           et testés")]), _vm._v(" "), _c('p', [_vm._v("Nous vous garantissons sur tous les produits le prix le plus bas du marché")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Aliments")]), _vm._v(" : Royal canin,\n         Hill's, Virbac,\n         Proplan, Specific\n       ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Antiparasitaires")]), _vm._v(" : "), _c('strong', [_vm._v("Collier")]), _vm._v(" scalibor,\n         Seresto "), _c('strong', [_vm._v("comprimés")]), _vm._v(" bravecto,\n         Nexguard, Credelio\n       ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pipettes")]), _vm._v(" : Advantix, Stronghold, Frontline")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Vermifuges")]), _vm._v(": Drontal, Milbemax, Eqvalan, Panacur")])])])])])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "order"
    }
  }, [_c('h2', [_vm._v(" Commander ")]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Votre nom"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Votre prénom"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Votre numéro de téléphone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Votre email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Votre commande"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Commander")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/fr"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/cat"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/es"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "infos"
    }
  }, [_c('h2', [_vm._v(" Informacions pràctiques ")]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" On trobar-nos ")]), _vm._v(" "), _c('p', [_vm._v(" HOSPITAL VETERINARI")]), _vm._v(" "), _c('p', [_vm._v(" Carrer Sant Jordi n°37")]), _vm._v(" "), _c('p', [_vm._v(" AD200 PAS DE LA CASA")]), _vm._v(" "), _c('p', [_vm._v("ANDORRA")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.google.fr/maps/place/Hospital+Veterinari/@42.5433291,1.7292353,17z/data=!3m1!4b1!4m5!3m4!1s0x12af7d8c7a8fdecb:0x9b2dad0f8b06fd2e!8m2!3d42.5433252!4d1.7314186",
      "target": "_blank"
    }
  }, [_vm._v("Veure mapa")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Nostres horaris ")]), _vm._v(" "), _c('p', [_vm._v("9h30-13h00 i 15h00-19h00")]), _vm._v(" "), _c('p', [_vm._v(" La clínica esta tancada els dies 01/01, 14/03, 8/09, 25/12")]), _vm._v(" "), _c('p', [_vm._v(" Les cures es fan unicament amb cita prèvia")]), _vm._v(" "), _c('p', [_vm._v(" Per la cirurgià, els animals seran depositats a les 8h30 del matí i\n        recuperats a les 16h")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Contactar-nos ")]), _vm._v(" "), _c('p', [_vm._v(" (FR) +33681459871 ")]), _vm._v(" "), _c('p', [_vm._v(" (AND) +376855536 ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:vetopas@andorra.ad",
      "target": "_blank"
    }
  }, [_vm._v("vetopas@andorra.ad")])])])])])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "infos"
    }
  }, [_c('h2', [_vm._v(" Informations ")]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Where to find us ")]), _vm._v(" "), _c('p', [_vm._v(" HOSPITAL VETERINARI")]), _vm._v(" "), _c('p', [_vm._v(" Carrer Sant Jordi n°37")]), _vm._v(" "), _c('p', [_vm._v(" AD200 PAS DE LA CASA")]), _vm._v(" "), _c('p', [_vm._v("ANDORRA")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.google.fr/maps/place/Hospital+Veterinari/@42.5433291,1.7292353,17z/data=!3m1!4b1!4m5!3m4!1s0x12af7d8c7a8fdecb:0x9b2dad0f8b06fd2e!8m2!3d42.5433252!4d1.7314186",
      "target": "_blank"
    }
  }, [_vm._v("See map")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Opening time ")]), _vm._v(" "), _c('p', [_vm._v("9h30-13h00 and 15h00-19h00")]), _vm._v(" "), _c('p', [_vm._v(" The veterinary clinic is closed on days 01/01, 14/03, 8/09, 25/12")]), _vm._v(" "), _c('p', [_vm._v(" Medical cares are made on appointment only ")]), _vm._v(" "), _c('p', [_vm._v(" For surgery, animals are left at 8:30am and taken back at 4pm")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Contact us ")]), _vm._v(" "), _c('p', [_vm._v(" (FR) +33681459871 ")]), _vm._v(" "), _c('p', [_vm._v(" (AND) +376855536 ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:vetopas@andorra.ad",
      "target": "_blank"
    }
  }, [_vm._v("vetopas@andorra.ad")])])])])])
}]}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "contactUs"
    }
  }, [_c('h2', [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Votre email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Sujet"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "textarea",
    attrs: {
      "type": "textarea",
      "rv-model": "message"
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Envoyer email")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "philosophy"
    }
  }, [_c('h2', [_vm._v("Un enfocament global de la salut basat en la prevenció")]), _vm._v(" "), _c('div', {
    staticClass: "philosophy"
  }, [_c('h3', [_vm._v("Nutrició")]), _vm._v(" "), _c('h3', [_vm._v("Comportament")]), _vm._v(" "), _c('h3', [_vm._v("Homeopatia")])])])])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Serveis a la recepció ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consell veterinari gratuït")]), _vm._v(" "), _c('p', [_vm._v("Us escoltem")]), _vm._v(" "), _c('p', [_vm._v("Us oferim una solució global personalitzada")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Venda")]), _vm._v(" "), _c('p', [_vm._v("Només oferim productes d'alta qualitat que hem estudiat i provat")]), _vm._v(" "), _c('p', [_vm._v("Garantim en tots els productes el preu més baix en el mercat")])])])])])
}]}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h2', [_vm._v(" Nuestro equipo ")]), _vm._v(" "), _c('div', {
    staticClass: "staff"
  }, [_c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(2),
      "alt": "Estéfania XARPELL, Vétérinaire"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Estéfania XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduada de la Escuela de Veterinaria de Toulouse, CES de nutrición de la Escuela veterinaria Maison Alfort, DU de homeopatía de la Facultad de Medicina de Marsella.")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1),
      "alt": "Ainhoa XARPELL, Pharmacienne"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Ainhoa XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduada de la Universidad de Farmacia de Barcelona (UB), ingeniera de la Escuela Superior de Química Física Electrónica de Lyon (CPE Lyon)")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4),
      "alt": "Michel HEINZELMEIER, Relations client"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Michel HEINZELMEIER")]), _vm._v(" "), _c('p', [_vm._v("Ingeniero, CAAE del IAE de Toulon")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "imgF"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "Frédérique CHADERAT, Responsable informatique"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Frédérique CHADERAT")]), _vm._v(" "), _c('p', [_vm._v("Ingeniero. Responsable informático")])])])])])
}]}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "contactUs"
    }
  }, [_c('h2', [_vm._v(" Contact us ")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subject"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "textarea",
    attrs: {
      "type": "textarea",
      "rv-model": "message"
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Send email")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Serveis amb cita ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Cirurgia ")]), _vm._v(" "), _c('p', [_vm._v(" Cirurgia de teixits tous ")]), _vm._v(" "), _c('P', [_vm._v(" Ovariectomia ")]), _vm._v(" "), _c('P', [_vm._v(" Castració ")]), _vm._v(" "), _c('p', [_vm._v(" Odontologia ")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consulta")]), _vm._v(" "), _c('p', [_vm._v("Enfocament global basat en la nutrició i el comportament per\n           aconseguir junts el benestar del teu company.")]), _vm._v(" "), _c('p', [_vm._v("Consultes homeopàtiques")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Plataforma tècnica")]), _vm._v(" "), _c('p', [_vm._v("Echografia")]), _vm._v(" "), _c('p', [_vm._v("Radiografia")]), _vm._v(" "), _c('p', [_vm._v("Hematologia")]), _vm._v(" "), _c('p', [_vm._v("Bioquímica")])])
}]}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "philosophy"
    }
  }, [_c('h2', [_vm._v("Un enfoque global de la salud basado en la prevención")]), _vm._v(" "), _c('div', {
    staticClass: "philosophy"
  }, [_c('h3', [_vm._v("Nutrición")]), _vm._v(" "), _c('h3', [_vm._v("Comportamiento")]), _vm._v(" "), _c('h3', [_vm._v("Homeopatía")])])])])
}]}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Servicios con cita ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Cirugía")]), _vm._v(" "), _c('p', [_vm._v("Cirugía de tejidos blandos")]), _vm._v(" "), _c('p', [_vm._v("Ovariectomía")]), _vm._v(" "), _c('p', [_vm._v("Castración")]), _vm._v(" "), _c('p', [_vm._v("Odontología")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consulta")]), _vm._v(" "), _c('p', [_vm._v("Enfoque global basado en la nutrición y el comportamiento para\n             para lograr juntos el bienestar de tu compañero.")]), _vm._v(" "), _c('p', [_vm._v("Consultas homeopáticas")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Meseta técnica")]), _vm._v(" "), _c('p', [_vm._v("Ecografía")]), _vm._v(" "), _c('p', [_vm._v("Radiografía")]), _vm._v(" "), _c('p', [_vm._v("Hematología")]), _vm._v(" "), _c('p', [_vm._v("Bioquímica")])])])])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h2', [_vm._v(" Our team ")]), _vm._v(" "), _c('div', {
    staticClass: "staff"
  }, [_c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(2),
      "alt": "Estéfania XARPELL, Vétérinaire"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Estéfania XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduated from the Toulouse Veterinary School, CES of nutrition from the Maison Alfort veterinary school, DU of homeopathy from the Faculty of Medicine of Marseille.")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1),
      "alt": "Ainhoa XARPELL, Pharmacienne"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Ainhoa XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduated from the University of Pharmacy of Barcelona (UB), engineer from the Higher School of Chemistry Electronic Physics of Lyon (CPE Lyon)")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4),
      "alt": "Michel HEINZELMEIER, Relations client"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Michel HEINZELMEIER")]), _vm._v(" "), _c('p', [_vm._v("Engineer, CAAE of the IAE of Toulon")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "imgF"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "Frédérique CHADERAT, Responsable informatique"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Frédérique CHADERAT")]), _vm._v(" "), _c('p', [_vm._v("Engineer. IT manager")])])])])])
}]}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hamburgerButton"
  }, [_c('img', {
    attrs: {
      "id": "menuButton",
      "src": __webpack_require__(8)
    },
    on: {
      "click": _vm.toggleMenu
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])])])]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "menuMobile"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "close"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("Close menu")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeContainer"
  }, [_c('h1', [_vm._v("Welcome to Vetopas ")])])
}]}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Welcoming services ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Free vererinary advices")]), _vm._v(" "), _c('p', [_vm._v("We listen to you")]), _vm._v(" "), _c('p', [_vm._v("We provide you a personnalised global solution")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Sale")]), _vm._v(" "), _c('p', [_vm._v("We only provide you studied and tested high quality products")]), _vm._v(" "), _c('p', [_vm._v("We guarantee on all products the lowest price on the market")])])])])])
}]}

/***/ })
],[39]);


// WEBPACK FOOTER //
// static/js/app.c60dcbaf1f00aafe15ed.js